import { Navigate, useParams } from 'react-router-dom';
import ProductsData from '../data/productsInfo.json';
import { useEffect } from 'react';
import { TypeMap } from '../utils/constants';
import logo from '../images/glometal-logo.PNG';

const Products = () => {
  const { type } = useParams();

  const allProducts = ProductsData.filter(product => product.categories.includes(TypeMap[type]));
  const mainProduct = allProducts.find(product => product.code === TypeMap[type]);

  useEffect(() => {
    document.title = `Glometal® - ${mainProduct?.title}`;
    window.scrollTo(0, 0);
  }, []);

  const getSrc = (code) => {
    try {
      return require(`../images/products/${type}-${code}.png`);
    } catch (error) {
      return logo;
    }
  }

  if (allProducts.length === 0 || !mainProduct) {
 return <Navigate to="/404" replace />;
  }

  return (
    <div className="products-page">
      <div className='white-cards-wrapper'>
        <h3 style={{ color: '#e47931' }}>Our Products</h3>
        <h1>{mainProduct?.title}</h1>
        <div className='white-card-container'>
          {allProducts.map((product, index) => (!product.hidden &&
            <a href={`/product/${type}/${product.code}`} className='white-card' key={index}>
              <img src={getSrc(product.code)} alt={product.title} />
              <h3>{product.title}</h3>
              <p>Code: {product.code}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;